"use client";

import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/pagination";

const frameworkItems = [
  {
    title: "Skill-based higher education",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/Skills-in-higher-education.jpg",
  },
  {
    title: "Industry immersion and workplace learning",
    image:
      "https://cdn.msu.edu.in/school_of_health_science_and_technology_students_af7ff3ca2c.jpg",
  },
  {
    title: "Outcome-based evaluation",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00732-min.JPG",
  },
  {
    title: "Expert mentorship",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00740-min.JPG",
  },
];

export default function PedagogicalFramework() {
  return (
    <section className="page-container py-8 md:py-16 bg-white">
      {/* Header */}
      <div className="mb-12">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Our Pedagogical Framework
        </h2>
        <p className="text-black text-sm md:text-base lg:text-lg max-w-4xl leading-relaxed">
          Below we have discussed some elements to create a learning ecosystem
          where students develop knowledge, skills, confidence, and readiness to
          succeed in the real world.
        </p>
      </div>

      {/* Mobile Swiper (< 768px) */}
      <div className="block md:hidden">
        {/* Navigation Buttons */}
        <div className="flex justify-end gap-3 mb-4">
          <button
            id="pfPrev"
            className="cursor-pointer bg-white border border-gray-300 rounded-full p-2 shadow-sm hover:bg-gray-50 transition-colors"
            aria-label="Previous"
          >
            <svg
              className="w-5 h-5 text-gray-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <button
            id="pfNext"
            className="cursor-pointer bg-white border border-gray-300 rounded-full p-2 shadow-sm hover:bg-gray-50 transition-colors"
            aria-label="Next"
          >
            <svg
              className="w-5 h-5 text-gray-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>

        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={20}
          loop={true}
          slidesPerView={1.2}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          navigation={{
            prevEl: "#pfPrev",
            nextEl: "#pfNext",
          }}
          className="pedagogical-swiper w-full"
        >
          {frameworkItems.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="bg-white shadow-lg overflow-hidden flex flex-col h-full">
                <div className="relative aspect-[4/3]">
                  <Image
                    src={item.image}
                    alt={item.title}
                    fill
                    className="object-cover"
                  />
                </div>
                <div className="p-5 flex-grow flex items-center">
                  <h3 className="text-gray-800 font-medium text-base leading-snug">
                    {item.title}
                  </h3>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Desktop Grid (>= 768px) */}
      <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-6">
        {frameworkItems.map((item, index) => (
          <div
            key={index}
            className="bg-white shadow-lg overflow-hidden flex flex-col group"
          >
            <div className="relative aspect-[4/3] overflow-hidden">
              <Image
                src={item.image}
                alt={item.title}
                fill
                className="object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-6 flex-grow flex items-center">
              <h3 className="text-gray-900 font-semibold text-lg leading-tight">
                {item.title}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
